(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["colour-group"] && !Shopify.designMode) return;
  try {
    class ColourGroup extends HTMLElement {
    constructor() {
      super();
      this.onToggleClick = this.onToggleClick.bind(this);
      this.onItemEnter = this.onItemEnter.bind(this);
      this.onItemLeave = this.onItemLeave.bind(this);
    }

    connectedCallback() {
      this.toggleButton = this.querySelector('[data-colour-group-toggle]');
      if (this.toggleButton) {
        this.toggleButton.addEventListener('click', this.onToggleClick);
      }

      this.colourLabel = this.querySelector('[data-colour-group-label]');
      this.items = Array.from(this.querySelectorAll('.colour-group__item'));
      this.items.forEach((item) => {
        item.addEventListener('mouseenter', this.onItemEnter);
        item.addEventListener('mouseleave', this.onItemLeave);
        item.addEventListener('focusin', this.onItemEnter);
        item.addEventListener('focusout', this.onItemLeave);
      });
    }

    disconnectedCallback() {
      if (this.toggleButton) {
        this.toggleButton.removeEventListener('click', this.onToggleClick);
      }

      this.items?.forEach((item) => {
        item.removeEventListener('mouseenter', this.onItemEnter);
        item.removeEventListener('mouseleave', this.onItemLeave);
        item.removeEventListener('focusin', this.onItemEnter);
        item.removeEventListener('focusout', this.onItemLeave);
      });
    }

    onToggleClick() {
      const expanded = this.classList.toggle('is-grid');
      this.toggleButton.setAttribute('aria-expanded', String(expanded));
    }

    onItemEnter(event) {
      const item = event.currentTarget;
      const bubble = item.querySelector('.colour-group__tooltip-bubble');

      if (this.colourLabel) {
        this.colourLabel.textContent = item.dataset.colourName;
      }

      if (!bubble) return;

      bubble.style.removeProperty('--colour-group-tooltip-shift');

      const bubbleRect = bubble.getBoundingClientRect();
      const bounds = this.getBoundingClientRect();
      const pad = 8;
      let shift = 0;

      if (bubbleRect.left < bounds.left + pad) {
        shift = bounds.left + pad - bubbleRect.left;
      } else if (bubbleRect.right > bounds.right - pad) {
        shift = bounds.right - pad - bubbleRect.right;
      }

      if (shift !== 0) {
        bubble.style.setProperty('--colour-group-tooltip-shift', `${shift}px`);
      }
    }

    onItemLeave(event) {
      if (event.type === 'focusout' && event.currentTarget.contains(event.relatedTarget)) return;
      if (!this.colourLabel) return;

      this.colourLabel.textContent = this.colourLabel.dataset.selectedColour;
    }
  }

  if (!customElements.get('colour-group')) {
    customElements.define('colour-group', ColourGroup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-wrapping-script"] && !Shopify.designMode) return;
  try {
    const GIFT_WRAPPING_NOTE = 'Gift wrapping'
const GIFT_WRAPPING_NOTE_VALUE = 'Yes'
const GIFT_WRAPPING_ID = '_gift_wrap_id'
const GIFT_WRAPPING_VARIANT = '_gift_wrap_variant'
const GIFT_WRAPPING_FOR = '_gift_wrap_for'
const GIFT_WRAPPING_PARENT = 'Gift wrapping for'
const GIFT_WRAPPING_REPAIR_KEY = 'gift-wrapping-repair'

const giftWrappingRoot = () => window.Shopify?.routes?.root || '/'

const giftWrappingConfig = () => document.getElementById('gift-wrapping-config')

const showGiftWrappingError = (message) => {
  document.dispatchEvent(new CustomEvent('toast:show', {
    detail: {
      message: message || giftWrappingConfig()?.dataset.errorMessage || 'Gift wrapping could not be added. Please try again.',
      tone: 'error'
    }
  }))
}

const giftWrappingSections = () => {
  const sections = new Set()
  document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
    bubbles: true,
    detail: { sections }
  }))
  return [...sections].join(',')
}

const postGiftWrapping = async (path, body) => {
  const response = await fetch(`${giftWrappingRoot()}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(body)
  })
  const data = await response.json()
  if (!response.ok) {
    throw new Error(data.description || data.message || giftWrappingConfig()?.dataset.errorMessage)
  }
  return data
}

const fetchGiftWrappingCart = async () => {
  const response = await fetch(`${giftWrappingRoot()}cart.js`, {
    headers: { Accept: 'application/json' },
    cache: 'no-store'
  })
  if (!response.ok) {
    throw new Error('Cart could not be loaded')
  }
  return response.json()
}

const visibleGiftWrappingCount = (cart) => {
  return cart.items.reduce((count, item) => {
    if (item.properties && item.properties[GIFT_WRAPPING_FOR]) {
      return count
    }
    return count + item.quantity
  }, 0)
}

const updateGiftWrappingCount = (cart) => {
  if (!cart?.items || visibleGiftWrappingCount(cart) === cart.item_count) {
    return
  }
  const count = visibleGiftWrappingCount(cart)
  document.querySelectorAll('cart-count').forEach((element) => {
    element.hidden = count === 0
    const label = element.querySelector('span')
    if (label) {
      label.textContent = String(count)
    }
  })
}

const normalizeGiftWrappingProperties = (value) => {
  if (!value) {
    return {}
  }
  if (Array.isArray(value)) {
    return Object.fromEntries(value)
  }
  return { ...value }
}

const readGiftWrappingProperties = (button) => {
  const source = button.closest('.gift-wrapping__card')?.querySelector('[data-gift-wrapping-properties]')
  if (!source) {
    return {}
  }
  return normalizeGiftWrappingProperties(JSON.parse(source.textContent))
}

const publishGiftWrappingCart = async (cart, sections) => {
  if (window.themeVariables?.settings?.pageType === 'cart') {
    window.location.reload()
    return
  }
  updateGiftWrappingCount(cart)
  if (!sections) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }))
    return
  }
  cart.sections = sections
  document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
    bubbles: true,
    detail: {
      baseEvent: 'line-item:change',
      cart
    }
  }))
}

let giftWrappingQueue = Promise.resolve()
const enqueueGiftWrapping = (task) => {
  giftWrappingQueue = giftWrappingQueue.then(task).catch(() => {})
  return giftWrappingQueue
}

const reconcileGiftWrapping = async () => {
  const cart = await fetchGiftWrappingCart()
  const children = new Map()
  const parents = []

  cart.items.forEach((item) => {
    const properties = item.properties || {}
    if (properties[GIFT_WRAPPING_FOR]) {
      children.set(String(properties[GIFT_WRAPPING_FOR]), item)
    } else if (properties[GIFT_WRAPPING_ID]) {
      parents.push(item)
    }
  })

  const updates = {}
  const missing = []
  const usedKeys = new Set()

  parents.forEach((parent) => {
    const linkId = String(parent.properties[GIFT_WRAPPING_ID])
    const child = children.get(linkId)
    if (!child) {
      if (parent.properties[GIFT_WRAPPING_VARIANT]) {
        missing.push({
          variantId: parent.properties[GIFT_WRAPPING_VARIANT],
          quantity: parent.quantity,
          linkId,
          parentTitle: parent.product_title || parent.title
        })
      }
      return
    }
    usedKeys.add(child.key)
    if (child.quantity !== parent.quantity) {
      updates[child.key] = parent.quantity
    }
  })

  children.forEach((child) => {
    if (!usedKeys.has(child.key)) {
      updates[child.key] = 0
    }
  })

  let changed = false
  if (Object.keys(updates).length > 0) {
    const updatedCart = await postGiftWrapping('cart/update.js', { updates })
    const applied = Object.entries(updates).every(([key, quantity]) => {
      const item = updatedCart.items.find((line) => line.key === key)
      return quantity === 0 ? !item : item?.quantity === quantity
    })
    changed = applied
  }

  if (missing.length > 0) {
    let attempts = 2
    try {
      attempts = Number(window.sessionStorage.getItem(GIFT_WRAPPING_REPAIR_KEY) || 0)
    } catch {
      attempts = 2
    }
    if (attempts < 2) {
      try {
        window.sessionStorage.setItem(GIFT_WRAPPING_REPAIR_KEY, String(attempts + 1))
      } catch {
        attempts = 2
      }
    }
    if (attempts < 2) {
      await postGiftWrapping('cart/add.js', {
        items: missing.map((entry) => ({
          id: giftWrappingVariantId(entry.variantId),
          quantity: entry.quantity,
          properties: {
            [GIFT_WRAPPING_FOR]: entry.linkId,
            [GIFT_WRAPPING_PARENT]: entry.parentTitle
          }
        }))
      })
      changed = true
      try {
        window.sessionStorage.removeItem(GIFT_WRAPPING_REPAIR_KEY)
      } catch {
      }
    }
  } else {
    try {
      window.sessionStorage.removeItem(GIFT_WRAPPING_REPAIR_KEY)
    } catch {
    }
  }

  if (!changed) {
    updateGiftWrappingCount(cart)
    return
  }

  const nextCart = await fetchGiftWrappingCart()
  await publishGiftWrappingCart(nextCart)
}

const asGiftWrappingField = (element) => {
  if (!element || element instanceof RadioNodeList || typeof element.name !== 'string') {
    return null
  }
  return element
}

const giftWrappingVariantId = (value) => {
  const id = Number(value)
  return Number.isSafeInteger(id) ? id : value
}

const giftWrappingLinkId = () => window.crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`

const formatGiftWrappingMoney = (cents) => {
  const settings = window.themeVariables?.settings || {}
  const format = settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat
  const placeholder = /\{\{\s*(\w+)\s*\}\}/
  const withDelimiters = (amount, precision, thousands, decimal) => {
    const number = (amount / 100).toFixed(precision)
    const parts = number.split('.')
    const whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`)
    return parts[1] ? `${whole}${decimal}${parts[1]}` : whole
  }
  const formats = {
    amount: (amount) => withDelimiters(amount, 2, ',', '.'),
    amount_no_decimals: (amount) => withDelimiters(amount, 0, ',', '.'),
    amount_with_comma_separator: (amount) => withDelimiters(amount, 2, '.', ','),
    amount_no_decimals_with_comma_separator: (amount) => withDelimiters(amount, 0, '.', ','),
    amount_with_apostrophe_separator: (amount) => withDelimiters(amount, 2, "'", '.'),
    amount_no_decimals_with_space_separator: (amount) => withDelimiters(amount, 0, ' ', ''),
    amount_with_space_separator: (amount) => withDelimiters(amount, 2, ' ', ','),
    amount_with_period_and_space_separator: (amount) => withDelimiters(amount, 2, ' ', '.')
  }
  if (!format) {
    return (cents / 100).toFixed(2)
  }
  return format.replace(placeholder, (_match, key) => (formats[key] || formats.amount)(cents))
}

const giftWrappingBasePrices = new WeakMap()

const giftWrappingBasePrice = (form) => {
  if (giftWrappingBasePrices.has(form)) {
    return giftWrappingBasePrices.get(form)
  }
  const picker = document.querySelector(`variant-picker[form-id="${CSS.escape(form.id)}"] script[data-variant]`)
  if (!picker) {
    return null
  }
  try {
    const price = JSON.parse(picker.textContent).price
    if (price != null) {
      giftWrappingBasePrices.set(form, price)
    }
    return price ?? null
  } catch {
    return null
  }
}

const setGiftWrappingSalePrice = (salePrice, formatted, includeWrapping) => {
  const textNode = [...salePrice.childNodes].find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim())
  if (!textNode) {
    return
  }
  if (!salePrice.dataset.giftWrappingBasePrice) {
    salePrice.dataset.giftWrappingBasePrice = textNode.textContent
  }
  textNode.textContent = includeWrapping ? ` ${formatted}` : salePrice.dataset.giftWrappingBasePrice
}

const syncGiftWrappingPrice = (form) => {
  const toggle = form.querySelector('[data-gift-wrapping-toggle]')
  const basePrice = giftWrappingBasePrice(form)
  if (!toggle || basePrice == null) {
    return
  }
  const total = basePrice + (toggle.checked ? Number(toggle.dataset.giftWrappingPrice || 0) : 0)
  const info = form.closest('.product-info')
  const targets = [
    info?.querySelector('[data-block-type="price"] sale-price'),
    document.querySelector(`product-sticky-add-to-cart[main-product-form="${CSS.escape(form.id)}"] sale-price`)
  ]
  targets.filter(Boolean).forEach((salePrice) => setGiftWrappingSalePrice(salePrice, formatGiftWrappingMoney(total), toggle.checked))
}

const collectGiftWrappingFormProperties = (form) => {
  const properties = {}
  ;[...form.elements].forEach((field) => {
    if (!field.name?.startsWith('properties[')) {
      return
    }
    if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) {
      return
    }
    if (field.disabled || field.value === '') {
      return
    }
    properties[field.name.slice('properties['.length, -1)] = field.value
  })
  return properties
}

const finishGiftWrappingAdd = async (form, added) => {
  if (window.themeVariables?.settings?.cartType === 'page' || window.themeVariables?.settings?.pageType === 'cart') {
    window.location.href = `${giftWrappingRoot()}cart`
    return
  }

  if (!added.sections) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }))
    return
  }

  const cart = await fetchGiftWrappingCart()
  cart.sections = added.sections
  const items = added.items || []
  form.dispatchEvent(new CustomEvent('variant:add', {
    bubbles: true,
    detail: { items, cart }
  }))
  document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
    bubbles: true,
    detail: {
      baseEvent: 'variant:add',
      cart
    }
  }))

  const addedMessage = window.themeVariables?.strings?.addedToCart || ''
  const productTitleToken = '{' + '{product_title}' + '}'
  if (window.themeVariables?.settings?.cartType === 'message') {
    document.dispatchEvent(new CustomEvent('toast:show', {
      detail: {
        message: addedMessage.replace(productTitleToken, items[0]?.title || '')
      }
    }))
  } else if (window.themeVariables?.settings?.cartType === 'drawer' && typeof announceStatus === 'function') {
    announceStatus(items.map((item) => addedMessage.replace(productTitleToken, item?.title || '')).join(', '))
  }
}

const addGiftWrappingFromForm = async (form, toggle) => {
  const idField = asGiftWrappingField(form.elements.namedItem('id'))
  const quantityField = asGiftWrappingField(form.elements.namedItem('quantity'))
  const sellingPlanField = asGiftWrappingField(form.elements.namedItem('selling_plan'))
  const quantity = Number(quantityField?.value || 1)
  const linkId = giftWrappingLinkId()
  const properties = collectGiftWrappingFormProperties(form)
  properties[GIFT_WRAPPING_NOTE] = GIFT_WRAPPING_NOTE_VALUE
  properties[GIFT_WRAPPING_ID] = linkId
  properties[GIFT_WRAPPING_VARIANT] = toggle.dataset.giftWrappingVariant

  const parent = {
    id: giftWrappingVariantId(idField.value),
    quantity,
    properties
  }
  if (sellingPlanField?.value) {
    parent.selling_plan = Number(sellingPlanField.value)
  }

  const payload = {
    items: [
      parent,
      {
        id: giftWrappingVariantId(toggle.dataset.giftWrappingVariant),
        quantity,
        properties: {
          [GIFT_WRAPPING_FOR]: linkId,
          [GIFT_WRAPPING_PARENT]: toggle.dataset.giftWrappingParentTitle || ''
        }
      }
    ]
  }
  const sections = giftWrappingSections()
  if (sections) {
    payload.sections = sections
  }

  const added = await postGiftWrapping('cart/add.js', payload)
  await finishGiftWrappingAdd(form, added)
}

document.addEventListener('submit', (event) => {
  const form = event.target
  if (!(form instanceof HTMLFormElement) || !form.getAttribute('action')?.includes('/cart/add')) {
    return
  }
  const toggle = form.querySelector('[data-gift-wrapping-toggle]')
  if (!toggle?.checked || !toggle.dataset.giftWrappingVariant) {
    return
  }
  if (event.submitter?.getAttribute('aria-busy') === 'true') {
    event.preventDefault()
    event.stopImmediatePropagation()
    return
  }
  if (!form.checkValidity()) {
    return
  }

  const idField = asGiftWrappingField(form.elements.namedItem('id'))
  if (!idField?.value) {
    return
  }

  event.preventDefault()
  event.stopImmediatePropagation()

  const submitButtons = [...form.elements].filter((button) => button.type === 'submit')
  submitButtons.forEach((button) => button.setAttribute('aria-busy', 'true'))
  document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }))

  enqueueGiftWrapping(async () => {
    try {
      await addGiftWrappingFromForm(form, toggle)
    } catch (error) {
      showGiftWrappingError(error.message)
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }))
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }))
      submitButtons.forEach((button) => {
        if (button.isConnected) {
          button.removeAttribute('aria-busy')
        }
      })
    }
  })
}, true)

document.addEventListener('change', (event) => {
  if (!event.target?.matches?.('[data-gift-wrapping-toggle]')) {
    return
  }
  const choice = event.target.closest('.gift-wrapping')?.querySelector('[data-gift-wrapping-choice]')
  if (choice) {
    choice.setAttribute('aria-pressed', event.target.checked ? 'true' : 'false')
  }
  const form = event.target.form || event.target.closest('form')
  if (form instanceof HTMLFormElement) {
    syncGiftWrappingPrice(form)
  }
})

document.addEventListener('variant:change', (event) => {
  const form = event.target
  if (!(form instanceof HTMLFormElement) || event.detail?.variant?.price == null) {
    return
  }
  giftWrappingBasePrices.set(form, event.detail.variant.price)
  syncGiftWrappingPrice(form)
})

document.addEventListener('click', (event) => {
  const choiceButton = event.target.closest('[data-gift-wrapping-choice]')
  if (choiceButton) {
    event.preventDefault()
    const toggle = choiceButton.closest('.gift-wrapping')?.querySelector('[data-gift-wrapping-toggle]')
    if (!toggle) {
      return
    }
    toggle.checked = !toggle.checked
    toggle.dispatchEvent(new Event('change', { bubbles: true }))
    return
  }

  const addButton = event.target.closest('[data-gift-wrapping-add]')
  const removeButton = event.target.closest('[data-gift-wrapping-remove]')
  const button = addButton || removeButton
  if (!button || button.getAttribute('aria-busy') === 'true') {
    return
  }

  event.preventDefault()
  button.setAttribute('aria-busy', 'true')
  button.disabled = true

  enqueueGiftWrapping(async () => {
    try {
      const properties = readGiftWrappingProperties(button)
      const quantity = Number(button.dataset.quantity || 1)
      if (addButton) {
        const linkId = giftWrappingLinkId()
        const variantId = button.dataset.variantId
        await postGiftWrapping('cart/change.js', {
          id: button.dataset.lineKey,
          quantity,
          properties: {
            ...properties,
            [GIFT_WRAPPING_NOTE]: GIFT_WRAPPING_NOTE_VALUE,
            [GIFT_WRAPPING_ID]: linkId,
            [GIFT_WRAPPING_VARIANT]: variantId
          }
        })
        const added = await postGiftWrapping('cart/add.js', {
          items: [{
            id: giftWrappingVariantId(variantId),
            quantity,
            properties: {
              [GIFT_WRAPPING_FOR]: linkId,
              [GIFT_WRAPPING_PARENT]: button.dataset.parentTitle || ''
            }
          }],
          sections: giftWrappingSections()
        })
        const cart = await fetchGiftWrappingCart()
        await publishGiftWrappingCart(cart, added.sections)
      } else {
        const nextProperties = {
          ...properties,
          [GIFT_WRAPPING_NOTE]: '',
          [GIFT_WRAPPING_ID]: '',
          [GIFT_WRAPPING_VARIANT]: ''
        }
        const sectionIds = giftWrappingSections()
        const changed = await postGiftWrapping('cart/change.js', {
          id: button.dataset.lineKey,
          quantity,
          properties: nextProperties,
          sections: sectionIds
        })
        let sections = changed.sections
        if (button.dataset.childKey) {
          const removed = await postGiftWrapping('cart/update.js', {
            updates: {
              [button.dataset.childKey]: 0
            },
            sections: sectionIds
          })
          sections = removed.sections
        }
        const cart = await fetchGiftWrappingCart()
        await publishGiftWrappingCart(cart, sections)
      }
    } catch (error) {
      showGiftWrappingError(error.message)
      if (button.isConnected) {
        button.removeAttribute('aria-busy')
        button.disabled = false
      }
    }
  })
})

document.addEventListener('cart:change', (event) => {
  if (window.themeVariables?.settings?.pageType === 'cart') {
    return
  }
  updateGiftWrappingCount(event.detail?.cart)
  enqueueGiftWrapping(() => reconcileGiftWrapping())
})

document.addEventListener('cart:refresh', () => {
  window.setTimeout(() => {
    enqueueGiftWrapping(async () => {
      updateGiftWrappingCount(await fetchGiftWrappingCart())
    })
  }, 250)
})

const startGiftWrapping = () => {
  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    if (form.querySelector('[data-gift-wrapping-toggle]')) {
      syncGiftWrappingPrice(form)
    }
  })
  enqueueGiftWrapping(() => reconcileGiftWrapping())
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startGiftWrapping, { once: true })
} else {
  startGiftWrapping()
}
  } catch(e) { console.error(e); }
})();

})();
